export const getDisable = (fieldName: string, disabledFieldNames?: Array<string> | 'all') => {
    let isDisable: boolean = false
    if (disabledFieldNames === 'all') {
        isDisable = true
    } else {
        if (disabledFieldNames && disabledFieldNames?.length > 0) {
            isDisable = disabledFieldNames?.indexOf(fieldName) !== -1
        }
    }
    return isDisable
}

export const getRequire = (fieldName: string, requiredFieldNames?: Array<string> | 'all') => {
    let isRequired: boolean = false
    if (requiredFieldNames === 'all') {
        isRequired = true
    } else {
        if (requiredFieldNames && requiredFieldNames?.length > 0) {
            isRequired = requiredFieldNames?.indexOf(fieldName) !== -1
        }
    }
    return isRequired
}

export const getDisplay = (fieldName: string, displayFieldNames?: Array<string> | 'all') => {
    let isDisplay: boolean = false
    if (displayFieldNames === 'all') {
        isDisplay = true
    } else {
        if (displayFieldNames && displayFieldNames?.length > 0) {
            isDisplay = displayFieldNames?.indexOf(fieldName) !== -1
        }
    }
    return isDisplay
}
